<template>
  <!-- 翠麟云剧场全部 -->
  <div class="Cinema-list bg-round bg-fff">
    <div>
      <div class="container" id="w-1200px">
        <Bread :list="breadList" class="ma-t-10" />
        <div class="ma-t-30  c-p">
            <div class="flex ma-t-20">
              <div class="ma-r-20 width10" :class="{'font-bold c-red':categoryId==0}" @click="categoryId=0;loadDataList('refresh')">全部类型</div>
              <div class="flex f-wrap width90">
                <div v-for="(item,index) in categoryList" :key="index" class="ma-r-20 ma-b-10" :class="{'font-bold c-red':categoryId==item.Id}" @click="categoryId=item.Id;loadDataList('refresh')">{{ item.Name }}</div>
              </div>
            </div>
            <div class="flex ma-t-20">
              <div class="ma-r-20 width10" :class="{'c-red font-bold':areas==0}" @click="areas=0;loadDataList('refresh')">全部地区</div>
              <div class="flex f-wrap width90">
                <div v-for="(item,index) in areasList" :key="index" class="ma-r-20 ma-b-10" :class="{'c-red font-bold':areas==item.Id}"  @click="areas=item.Id;loadDataList('refresh')">{{ item.Name }}</div>
              </div>
            </div>
            <div class="flex ma-t-20">
              <div class="ma-r-20 width10" :class="{'c-red font-bold':age==0}"  @click="age=0;loadDataList('refresh')">全部年份</div>
              <div class="flex f-wrap width90">
                <div v-for="(item,index) in 7" :key="index" class="ma-r-20 ma-b-10" :class="{'c-red font-bold':age==new Date().getFullYear()-index}"  @click="age=new Date().getFullYear()-index;loadDataList('refresh')">{{ new Date().getFullYear()-index }}</div>
                <div class="ma-r-20 ma-b-10" :class="{'c-red font-bold':age==-1}"  @click="age=-1;loadDataList('refresh')">{{ new Date().getFullYear()-7 }}-更早</div>
              </div>
            </div>
            <div class="flex ma-t-20">
              <div class="ma-r-20 width10" :class="{'c-red font-bold':type==0}" @click="type=0;loadDataList('refresh')">付费类型</div>
              <div class="flex f-wrap width90">
                <div class="ma-r-20 ma-b-10" :class="{'c-red font-bold':type==1}" @click="type=1;loadDataList('refresh')">收费</div>
                <div class="ma-r-20 ma-b-10" :class="{'c-red font-bold':type==2}" @click="type=2;loadDataList('refresh')">付费</div>
              </div>
            </div>
            <div class="flex ma-t-20">
              <div class="c-p width10 ma-r-20 " :class="{'c-red font-bold':sortType==0}" @click="sortType=0;loadDataList('refresh')">综合排序</div>
              <div class="flex f-wrap width90 ">
                <div class="ma-r-20 ma-b-10" :class="{'c-red font-bold':sortType==1}" @click="sortType=1;loadDataList('refresh')">热度最高</div>
                <div class="ma-r-20 ma-b-10" :class="{'c-red font-bold':sortType==2}" @click="sortType=2;loadDataList('refresh')">最新上线</div>
                <div class="ma-r-20 ma-b-10" :class="{'c-red font-bold':sortType==3}" @click="sortType=3;loadDataList('refresh')">最多播放</div>
              </div>
            </div>
            <div class="flex ma-t-20 f-center">
              <div class="c-red font-bold ma-r-20 width10">关键字搜索</div>
              <div class="flex width30">
                <el-input v-model="name" placeholder="电影名称/导演姓名/主演姓名" class="input-br-round">
                  <i slot="suffix" class="el-input__icon el-icon-search" @click="loadDataList('refresh')"></i>
                </el-input>
              </div>
            </div>
        </div>

        <div class="flex f-wrap ma-t-30">
          <div class="box-item ma-b-40 t-center c-p" v-for="(item,index) in dataList" :key="index" @click="$router.push({path:'/movie/detail',query:{id:item.Id}})">
                <img :src="item.Image" width="100%" height="80%" class="img_cover b-r-15" alt="" srcset="">
                <div class="ma-t-20">{{ item.Name }}</div>
                <div class="ma-t-10">{{ item.Title }}</div>
            </div>
        </div>
        <div class="fy t-center">
        <el-pagination
          @current-change="handleCurrentChange"
          :hide-on-single-page="true"
          :current-page.sync="pageIndex"
          :page-size="pageSize"
          layout="prev, pager, next, jumper"
          :total="totals"
        ></el-pagination>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import Bread from "../components/Bread.vue";
import { getCinemaBanner, getCinemaCategory,getCinemaQueryAreas,getCinemaList } from "../api.js";
export default {
  components: {
    Bread,
  },
  data() {
    return {
      breadList: [
        {
          name: "翠麟云剧场",
          path: "/movie/index",
        },
      ],
      totals: 0, //一个分类下的总条数
      pageIndex: 1,
      pageSize:16,
      dataList:[],
      bannerList:[],//轮播图列表
      categoryList:[],//全部类型列表
      areasList:[],//全部地区列表
      sortType:0,//搜索条件 排序方式 1：热度最高 2：最新上线 3：最多播放
      areas:0,//搜索条件，全部地区 1
      categoryId:0,//搜索条件，全部动作
      type:0,//付费类型 1 收费，2付费
      age:0,//年份
      name:'',//搜索关键字
    };
  },
  created(){
    this.sortType = this.$route.query.sortType;
    this.areas = this.$route.query.areas;
    this.categoryId = this.$route.query.categoryId;
    this.loadData()
    this.loadDataList()
  },
  methods:{
    // 当前页改变时触发
    handleCurrentChange(e) {
      this.pageIndex = e ;
      this.loadDataList();
    },
    //获取数据
    loadData(){
      getCinemaBanner().then(res=>{
        this.bannerList=res.data.Data
      })
      getCinemaCategory().then(res=>{
        this.categoryList=res.data.Data
      })
      getCinemaQueryAreas().then(res=>{
        this.areasList=res.data.Data
      })
    },
    //获取列表
    loadDataList(type){
        if(type=='refresh'){
            this.pageIndex=1
        }
        getCinemaList({
            sortType:this.sortType,
            areas:this.areas,
            categoryId:this.categoryId,
            pageIndex:this.pageIndex,
            age:this.age,
            type:this.type,
            name:this.name,
            pageSize:this.pageSize
        }).then(res=>{
            this.dataList=res.data.Data.List
            this.totals = res.data.Data.TotalCount;
        })
    }
  }
};
</script>

<style scoped lang="scss">
.Cinema-list .container{
    min-height: 1150px;
    // background: #ffffff;
    box-sizing: border-box;
    padding: 30px 40px;
}
.box-item {
    width: 18%;
    height: 320px;
  }
  .box-item:not(:nth-child(5n)) {
    margin-right: calc(10% / 5);
  }
  ::v-deep .input-br-round .el-input__inner {
    border-radius: 50px;
  }
</style>